export enum DiningResultsLayout {
  Default = 'default',
  Map = 'map',
}
